
import { useState, useRef, useEffect } from "react";

import {
    FaChevronDown,
    FaUser,
    FaSignOutAlt,
    FaBars
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { auditsApi } from "../../features/audits/api/audits.api";
import { toast } from "react-hot-toast"
import { TOAST_ERROR_IDS } from "../../interaces/toast.ids.interface";
import "./topbar.css"
function Topbar({ onMenuClick, title }) {

    const [openMenu, setOpenMenu] = useState(false);
    const { user, logout } = useAuth();
    const menuRef = useRef(null);

    useEffect(() => {
        // Guardar timestamp de inicio de sesión si no existe
        if (!sessionStorage.getItem('sessionStart')) {
            sessionStorage.setItem('sessionStart', Date.now().toString());
        }

        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpenMenu(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleLogout = async (e) => {
        e.preventDefault();
        try {
            const sessionStart = parseInt(sessionStorage.getItem('sessionStart') || '0', 10);
            const sessionSecs = sessionStart ? Math.round((Date.now() - sessionStart) / 1000) : 0;
            const mins = Math.floor(sessionSecs / 60);
            const secs = sessionSecs % 60;
            const duracionStr = `${mins}m ${secs}s`;

            if (user) {
                await auditsApi.logout({
                    username: user.username || user.fullName || 'usuario',
                    role: user.role || 'N/A',
                    module: 'Dashboard',
                    action: 'Cierre de Sesión',
                    status: 'Correcto',
                    traceability: [
                        { evento: 'Cierre de Sesión', detalle: `El usuario cerró sesión. Duración de sesión: ${duracionStr}` }
                    ]
                });
            }
        } catch (error) {
            toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, { id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR })
            // No bloquear el logout si falla el log
        } finally {
            logout();
            window.location.href = '/';
        }
    };

    return (
        <header className="header-topbar">
            <div className="topbar-menu-slot">
                <button
                    type="button"
                    className="button-menu"
                    aria-label="Abrir menú de navegación"
                    onClick={() => onMenuClick && onMenuClick()}
                >
                    <FaBars aria-hidden="true" />
                </button>
            </div>
            <h1 className="topbar-title" title={title}>{title}</h1>

            <div className="main-div-topbar">

                <div
                    className="div-relative"
                    ref={menuRef}
                >
                    <div
                        className="second-div-topbar"
                        onClick={() => setOpenMenu(!openMenu)}
                    >
                        <div>
                            <strong className="strong-fullName">
                                {user.fullName || user.username || 'Usuario'}
                            </strong>

                            <small className="small-role">
                                {user.role || 'Rol'}
                            </small>
                        </div>

                        <FaChevronDown
                            className={`icon ${openMenu ? 'icon-open' : ''
                                }`}
                        />
                    </div>

                    <div
                        className={`div-information
                        ${openMenu
                                ? 'div-show-information'
                                : 'div-no-show-information'
                            }
                    `}
                    >

                        <NavLink to="/myProfile">
                            <button
                                className="button-mi-perfil"
                            >
                                <FaUser />
                                Mi Perfil
                            </button>
                        </NavLink>

                        <button
                            className="button-close-session"
                            onClick={handleLogout}
                        >
                            <FaSignOutAlt />
                            Cerrar Sesión
                        </button>

                    </div>

                </div>

            </div>

        </header>
    );
}

export default Topbar;
